<template>
    <p class="loan-repayment-amount">
        <span :class="['main-text', largeMobileValue ? 'large-main-text' : 'small-main-text']">
            {{ formatCurrency(offer.monthly_repayment_display) }}
        </span>

        <span
            v-if="showLabel && !isLineOfCredit"
            class="small-text d-flex align-self-start"
            v-html="$t('results.loanTermLabel', { termDisplay: offer.term_display })"
        >
        </span>

        <span
            v-else-if="showLabel && isLineOfCredit"
            class="small-text d-flex align-self-start"
            v-html="$t('results.monthlyRepaymentLabel')"
        >
        </span>

        <span
            v-else
            class="small-text d-flex align-self-start"
            v-html="$t('results.loanTerm', { termDisplay: offer.term_display })"
        >
        </span>
    </p>
</template>

<script>
import { formatCurrency } from '@js/utilities/number.js'

export default {
    props: {
        showLabel: {
            type: Boolean,
            default: true,
        },
        largeMobileValue: {
            type: Boolean,
            default: true,
        },
    },
    inject: ['offer'],
    methods: {
        formatCurrency: formatCurrency,
    },
    computed: {
        isLineOfCredit: function () {
            return this.offer.type === 'line_of_credit' && this.includeTerritories('usa')
        },
    },
}
</script>
